import { createAction, handleActions } from 'redux-actions';

import { List, Map, fromJS } from 'immutable';
import { pender } from 'redux-pender';
import axios from 'axios';

import * as tagLib from 'libs/tagLib';
import * as normalizer from 'libs/normalizer';

// action types
const INITIAL_STORE = 'tag/INITIAL_STORE';
const CHANGE_TAG = 'tag/CHANGE_TAG';
const CHANGE_PARAM = 'tag/CHANGE_PARAM';
const GET_TAG_INFO = 'tag/GET_TAG_INFO';
const POST_TAG_INFO = 'tag/POST_TAG_INFO';
const PUT_TAG_INFO = 'tag/PUT_TAG_INFO';
const DELETE_TAG_INFO = 'tag/DELETE_TAG_INFO';
const DELETE_ALL_TAG_INFO = 'tag/DELETE_ALL_TAG_INFO';
const TOGGLE_SEARCH_ACTIVE = 'tag/TOGGLE_SEARCH_ACTIVE';
const TOGGLE_EDITMODE = 'tag/TOGGLE_EDITMODE';
const TOGGLE_TAG_INITIAL = 'tag/TOGGLE_TAG_INITIAL';
const TOGGLE_ALL_TAG_INITIAL = 'tag/TOGGLE_ALL_TAG_INITIAL';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const changeTag = createAction(CHANGE_TAG);
export const changeParam = createAction(CHANGE_PARAM);
export const getTag = createAction(GET_TAG_INFO, tagLib.getTagAPI);
export const postTag = createAction(POST_TAG_INFO, tagLib.postTagAPI);
export const putTag = createAction(PUT_TAG_INFO, tagLib.putTagAPI);
export const deleteTag = createAction(DELETE_TAG_INFO, tagLib.deleteTagAPI);
export const deleteAllTag = createAction(DELETE_ALL_TAG_INFO, tagLib.deleteAllTagAPI);
export const toggleSearchActive = createAction(TOGGLE_SEARCH_ACTIVE);
export const toggleEditMode = createAction(TOGGLE_EDITMODE);
export const toggleTagInitial = createAction(TOGGLE_TAG_INITIAL);
export const toggleAllTagInitial = createAction(TOGGLE_ALL_TAG_INITIAL);

// initial state
const initialState = Map({
  needReload: false,
  // 이니셜로 정렬
  tagInitialOrdering: List([]),
  // 이니셜로 정렬
  tagInitial: Map({}),
  tagDataByTagNo: Map({}),
  param: Map({
    filter: Map({}),
    sort: [{ field: 'examNo', order: 'DESC' }],
    offset: 0,
    limit: 5
  }),
  // 태그 검색
  isSearchActive: false,
  // 수정 모드
  isEditMode: false,
  isAllOpen: true
});

// reducer
export default handleActions(
  {
    // store 초기화
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    [CHANGE_TAG]: (state, action) => {
      const { name, value } = action.payload;

      return state.set(name, value);
    },
    [CHANGE_PARAM]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['param', name], value);
    },
    // 태그 조회
    ...pender({
      type: GET_TAG_INFO,
      onSuccess: (state, action) => {
        if (typeof action.payload === 'undefined') {
          return state;
        }

        const { list } = action.payload.data;

        state = state.set('needReload', false);

        return state
          .set('tagInitialOrdering', fromJS(normalizer.tagNormalize(list, 'initialOrdering')))
          .set('tagInitial', fromJS(normalizer.tagNormalize(list)))
          .set('tagDataByTagNo', fromJS(normalizer.tagNormalize(list, 'tagNo')));
      },
      onFailure: (state, action) => {
        return state
          .set('tagDataByTagNo', Map({}))
          .set('tagInitialOrdering', List([]))
          .set('tagInitial', Map({}));
      }
    }),
    // 태그 추가
    ...pender({
      type: POST_TAG_INFO,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const tagInitial = list[0].tagInitial;

        // 이니셜 영역이 없으면 새로 만들고 태그 추가
        if (typeof state.getIn(['tagInitial', tagInitial]) === 'undefined') {
          return state
            .set(
              'tagInitialOrdering',
              state
                .get('tagInitialOrdering')
                .splice(0, 0, tagInitial)
                .sort()
            )
            .mergeIn(['tagInitial', tagInitial], normalizer.tagNormalize(list)[tagInitial])
            .setIn(['tagDataByTagNo', String(list[0].tagNo)], fromJS(list[0]));
        }

        // 이니셜 영역이 있으면 기존에 추가
        return state
          .setIn(
            ['tagInitial', tagInitial, 'tagItemList'],
            state.getIn(['tagInitial', tagInitial, 'tagItemList']).push(fromJS(list[0]))
          )
          .setIn(['tagDataByTagNo', String(list[0].tagNo)], fromJS(list[0]));
      },
      onFailure: (state, action) => {
        return state.set('tagInitial', Map({}));
      }
    }),
    // 태그 수정
    ...pender({
      type: PUT_TAG_INFO,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const beforeTagInitial = JSON.parse(action.payload.config.data).beforeTagInitial;
        const { tagNo, tagInitial, color } = list[0];
        const targetCount = state.getIn(['tagDataByTagNo', String(tagNo), 'targetCount']);
        list[0]['targetCount'] = targetCount;

        // *이니셜이 안바뀜 / 색상 수정 - 기존에 있던 태그에 내용만 수정
        if (tagInitial === beforeTagInitial || typeof beforeTagInitial === 'undefined') {
          const index = state
            .getIn(['tagInitial', tagInitial, 'tagItemList'])
            .findIndex(tag => tag.get('tagNo') === tagNo);

          return state
            .setIn(['tagInitial', tagInitial, 'tagItemList', index], fromJS(list[0]))
            .setIn(['tagDataByTagNo', String(tagNo)], fromJS(list[0]));
        }

        // *이니셜이 바꼈다.
        const beforeIndex = state
          .getIn(['tagInitial', beforeTagInitial, 'tagItemList'])
          .findIndex(tag => tag.get('tagNo') === tagNo);
        // 사이즈가 1이면 이니셜 영역도 같이 지워준다.
        const tagItemList = state.getIn(['tagInitial', tagInitial, 'tagItemList']);
        const deleteInitial = state.getIn(['tagInitial', beforeTagInitial, 'tagItemList']).size === 1 ? true : false;

        // 기존에 있던 이니셜은 삭제
        if (deleteInitial) {
          let prevData = state.get('tagInitialOrdering');
          const indexArray = prevData.findIndex(ti => ti === beforeTagInitial);
          prevData = prevData.splice(indexArray, 1);

          state = state.set('tagInitialOrdering', fromJS(prevData)).deleteIn(['tagInitial', beforeTagInitial]);
          // 이니셜은 놔두고 이니셜 데이터 안에 태그 정보만 삭제
        } else {
          state = state.deleteIn(['tagInitial', beforeTagInitial, 'tagItemList', beforeIndex]);
        }

        // 새로운 이니셜을 만든다 (기존에 없는 이니셜)
        if (typeof state.getIn(['tagInitial', tagInitial]) === 'undefined') {
          state = state
            .set(
              'tagInitialOrdering',
              state
                .get('tagInitialOrdering')
                .splice(0, 0, tagInitial)
                .sort()
            )
            .mergeIn(['tagInitial', tagInitial], normalizer.tagNormalize(list)[tagInitial]);
          // 이미 존재하는 이니셜인 경우
        } else {
          state = state.setIn(['tagInitial', tagInitial, 'tagItemList'], tagItemList.push(fromJS(list[0])));
        }

        return state.setIn(['tagDataByTagNo', String(tagNo)], fromJS(list[0]));
      },
      onFailure: (state, action) => {
        return state.set('tagInitial', Map({}));
      }
    }),
    // 태그 삭제
    ...pender({
      type: DELETE_TAG_INFO,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const { tagNo, tagInitial } = list[0];
        const index = state
          .getIn(['tagInitial', tagInitial, 'tagItemList'])
          .findIndex(tag => tag.get('tagNo') === tagNo);

        // 이니셜도 같이 삭제
        const deleteInitial = state.getIn(['tagInitial', tagInitial, 'tagItemList']).size === 1 ? true : false;
        if (deleteInitial) {
          let prevData = state.get('tagInitialOrdering');
          const indexArray = prevData.findIndex(ti => ti === tagInitial);
          prevData = prevData.splice(indexArray, 1);

          state = state.set('tagInitialOrdering', fromJS(prevData)).deleteIn(['tagInitial', tagInitial]);
        } else {
          state = state.setIn(
            ['tagInitial', tagInitial, 'tagItemList'],
            state.getIn(['tagInitial', tagInitial, 'tagItemList']).delete(index)
          );
        }
        return state.set('tagDataByTagNo', state.get('tagDataByTagNo').delete(String(tagNo)));
      },
      onFailure: (state, action) => {
        return state.set('tagInitial', Map({}));
      }
    }),
    // 태그 전체 삭제
    ...pender({
      type: DELETE_ALL_TAG_INFO,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;

        return state
          .set('tagInitialOrdering', List([]))
          .set('tagInitial', Map({}))
          .set('tagDataByTagNo', Map({}));
      },
      onFailure: (state, action) => {
        return state.set('tagInitial', Map({}));
      }
    }),
    // 태그 편집 모드
    [TOGGLE_SEARCH_ACTIVE]: (state, action) => {
      if (typeof action.payload === 'undefined') {
        return state.set('isSearchActive', !state.get('isSearchActive'));
      } else {
        return state.set('isSearchActive', action.payload);
      }
    },
    // 태그 편집 모드
    [TOGGLE_EDITMODE]: (state, action) => {
      if (typeof action.payload === 'undefined') {
        return state.set('isEditMode', !state.get('isEditMode'));
      } else {
        return state.set('isEditMode', action.payload);
      }
    },
    // 태그 펼치기 / 닫기
    [TOGGLE_TAG_INITIAL]: (state, action) => {
      const { tagInitial } = action.payload;

      return state.updateIn(['tagInitial', tagInitial], tag => tag.set('isView', !tag.get('isView')));
    },
    // 태그 전체 펼치기 / 닫기
    [TOGGLE_ALL_TAG_INITIAL]: (state, action) => {
      return state
        .set('isAllOpen', !state.get('isAllOpen'))
        .updateIn(['tagInitial'], eachTag =>
          eachTag.map(tagInitial => tagInitial.set('isView', !state.get('isAllOpen')))
        );
    }
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/tag.js